import { inject, injectable, singleton } from 'tsyringe';

import {
    AuthService,
    Credential,
    SystemType,
    UserInterface,
} from '@/v1/main/domain/auth';
import { AuthRepositoryImpl } from '@/v1/main/repositories';

@injectable()
@singleton()
export class AuthServiceImpl implements AuthService {
    public constructor(
        @inject(AuthRepositoryImpl)
        private _authRepo: AuthRepositoryImpl
    ) {
        console.log('new auth service');
    }

    public getSystemType(): SystemType {
        return this._authRepo.getSystemType();
    }
    public setSystemType(value: SystemType): void {
        this._authRepo.setSystemType(value);
    }

    public async getAccount(): Promise<string> {
        return await this._authRepo.getAccount();
    }
    public rememberAccount(value: string): void {
        this._authRepo.setAccount(value);
    }
    public clearRememberedAccount(): void {
        this._authRepo.setAccount();
    }

    public getLoginState(): boolean {
        const credential = this._authRepo.getCredential();
        return credential !== '';
    }
    public setCredential(value: Credential): void {
        this._authRepo.setCredential(value);
    }
    public clearCredential(): void {
        this._authRepo.setCredential();
    }

    public async login(account: string, password: string): Promise<void> {
        const result = await this._authRepo.login(account, password);
        await this._authRepo.setCredential(result);
    }
    public async logout(): Promise<void> {
        await this._authRepo.logout();
        this.clearCredential();
    }
    public async refreshToken(): Promise<void> {
        const result = await this._authRepo.refreshToken();
        await this._authRepo.setCredential(result);
    }
    public async changePassword(
        old_password: string,
        new_password: string
    ): Promise<void> {
        await this._authRepo.changePassword(old_password, new_password);
        this.clearCredential();
    }
    public async getUserInterface(): Promise<UserInterface> {
        const resp = await this._authRepo.getUserInterface();
        return resp;
    }
}
